import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconPhone = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "icon/phone",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M11.1654 0.667969H5.83203C4.72536 0.667969 3.83203 1.5613 3.83203 2.66797V13.3346C3.83203 14.4413 4.72536 15.3346 5.83203 15.3346H11.1654C12.272 15.3346 13.1654 14.4413 13.1654 13.3346V2.66797C13.1654 1.5613 12.272 0.667969 11.1654 0.667969ZM9.83203 14.0013H7.16536V13.3346H9.83203V14.0013ZM11.9987 12.0013H4.9987V2.66797H11.9987V12.0013Z",
			fill: "#959595"
		})
	})
});
export default SvgIconPhone;
